// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vRegion from 'v-region'

Vue.prototype.$BASE_URL = 'https://api.nongxiao123.com'
// Vue.prototype.$BASE_URL = 'https://api.lexiao123.cn'
// Vue.prototype.$BASE_URL = 'https://api.nongxiao123.com/yz'
Vue.prototype.$UPLOAD_PREFIX = 'https://openresource.nongxiao123.com/'
// Vue.prototype.$UPLOAD_PREFIX = 'https://openresource.lexiao123.cn/'

Vue.use(vRegion)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// export const config = new Vue({
//   data: {
//     // BASE_URL: 'https://api.nongxiao123.com',
//     BASE_URL: 'https://api.nongxiao123.com/yz',
//     UPLOAD_PREFIX: 'https://res.nongxiao123.com/',
//   }
// })


// WEBPACK FOOTER //
// ./src/main.js